import * as React from 'react';

import PrimaryButton from '../../../../../shared/buttons/PrimaryButton';

import DocumentPickerAdapter from '../../../../../shared/document_picker/DocumentPickerAdapter';
import AlertModal from '../../../../../shared/modals/AlertModal';

import {formatErrorMessages} from '../../../../../../helpers/errorMessages';

import Sound from '../../../../../../../domain/entities/Sound';

import NetSoundsRepository from '../../../../../../../data/repositories/writer/NetSoundsRepository';

interface Props {
  storyId: number;
  onSelectSound: (sound: Sound) => void;
}

const CreateSoundButton: React.FunctionComponent<Props> = props => {
  const {storyId, onSelectSound} = props;
  const [alertMessage, setAlertMessage] = React.useState<string | null>(null);
  const onPress = React.useCallback(() => {}, []);
  const onChangeFile = React.useCallback(
    (audio: File) => {
      const name = audio.name.split('.').slice(0, -1).join('.');
      new NetSoundsRepository()
        .create(
          {
            sound: {
              type: 'background_music',
              storyId,
              audio,
              name,
            },
          },
          {multipart: true},
        )
        .then((sound: Sound) => {
          onSelectSound(sound);
        })
        .catch(e => {
          setAlertMessage(formatErrorMessages({}, e));
        });
    },
    [setAlertMessage],
  );
  const handleRequestClose = React.useCallback(() => {
    setAlertMessage(null);
  }, [setAlertMessage]);
  const onFailFile = React.useCallback(
    (error: string) => {
      setAlertMessage(error);
    },
    [setAlertMessage],
  );
  return (
    <>
      <DocumentPickerAdapter
        type={'audio'}
        onChangeFile={onChangeFile}
        onFailFile={onFailFile}>
        <PrimaryButton onPress={onPress}>BGMをアップロードする</PrimaryButton>
      </DocumentPickerAdapter>
      <AlertModal visible={!!alertMessage} onCloseModal={handleRequestClose}>
        {alertMessage}
      </AlertModal>
    </>
  );
};

export default React.memo(CreateSoundButton);
